import createMiddleware from '../../utils/middleware-helper';
import * as AT from '../../action-types';
import { sdkSendMessage } from './sdk.actions';
import { changePatientValidationsConfig, createPatient, userConfirmedClearingForm, setPatientById } from '../../feature/patient-management/patient-management.actions';
import { PatientAppName, SdkEvents, SdkMessages, SdkResult, rxEventTypes } from './sdk.enums';
import { getMessageObject } from "../../utils";
import localStorageUtils from "../../../utils/local-storage";
import { sdkInitializationComplete } from '../shell/shell.actions';
import patientUtils from '../../feature/patient-management/patient-management.utils';

const { SDK } = AT;

export const middleware = ({ action, dispatch, getState }) => {
  const handleMessageEvent = event => {
    const eventId = +event.data.eventId;
    const data = event.data.data || event.data.payload;
    switch (eventId) {
      case rxEventTypes.patientAppReady:
        break;
      case rxEventTypes.patientAppInit:
        try {
          localStorageUtils.updateContext(JSON.stringify(data));
          dispatch(sdkInitializationComplete(data.selectedCompanyId));
          if (data.initialPatientData) {
            const state = getState();
            const dateOfBirthFormat = state.shell.fromUrl.dateOfBirthFormat
              || (state.shell.config.regulatorySettings && state.shell.config.regulatorySettings.dobMask)
              || null;
            const regulatoryDOBMask = state.shell.config.regulatorySettings
              ? state.shell.config.regulatorySettings.dobMask : null;
            dispatch(setPatientById(patientUtils.getPatientDtoFromRxAppData(data.initialPatientData, dateOfBirthFormat, regulatoryDOBMask)));
          }
        } catch (error) {
          console.error('[Patient App] Error updating context in local storage:', error);
        }
        break;
      case rxEventTypes.patientAppSetPatientValidationsConfig:
        dispatch(changePatientValidationsConfig(data));
        break;
      case rxEventTypes.patientAppCreatePatient:
        dispatch(createPatient());
        break;
      case rxEventTypes.patientAppClearPatient:
        dispatch(userConfirmedClearingForm());
        break;
      default:
        break;
    }
  };
  
  const { payload, type, sdkRequest } = action;

  const sdkSendMessageAppReady = {
    sdkRequest: {
      origin: '*',
      message: SdkMessages.SuccessInit,
      result: SdkResult.Success,
      event: SdkEvents.Init
    },
    data: {
      eventId: rxEventTypes.patientAppInit,
      data: 'Hello from Patient App',
      appName: PatientAppName,
      iframeId: payload.iframeId
    }
  };

  switch (type) {
    case AT.SDK_INIT: {
      window.addEventListener('message', handleMessageEvent, false);
      dispatch(sdkSendMessage(sdkSendMessageAppReady));
      break;
    }
    case AT.SDK_SEND_MESSAGE: {
      window.parent.postMessage({ ...payload, ...sdkRequest }, sdkRequest.origin);
      break;
    }
    case AT.SDK_CLOSE_ME: {
      const message = getMessageObject();
      message.data = { eventId: payload, data: null };
      dispatch(sdkSendMessage(message));
      break;
    }
    default:
      break;
  }
};

export default createMiddleware({
  feature: SDK
})(middleware);
